import React, { useState, useEffect } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useMembership } from "../../hooks/MembershipProvider/MembershipProvider";
import { useApi } from "../../hooks/ApiProvider/ApiProvider";
import "./MyPage.css";

import UserInfo from "./UserInfo";
import OrderInfo from "./OrderInfo";
import Coupon from "./Coupon";
import Banner from "../Banner/Banner";
import useAndroidBridge from "../../hooks/useAndroidBridge";
import YesNoPopup from "../YesNoPopup";

type SetStateAction<T> = T | ((prevState: T) => T);

const MyPage: React.FC = () => {
  const { user, isAuthenticated, logout, refreshUser } = useMembership();
  const { withdrawMembership } = useApi();
  const [userInfo, serUserInfo] = useState<SetStateAction<any>>({});
  const [actType, setActType] = useState<SetStateAction<any>>(false);
  const [data, setData] = useState<any | undefined>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // For mobile =================================================================================
  const { isEmbed } = useMembership();
  const { sendToAndroid, bridgeLogout } = useAndroidBridge();
  const [logOutgPopup, setLogOutgPopup] = useState(false);
  const [membershipOut, setMembershipOut] = useState(false);

  // 🎯 모바일 전용 로그아웃 함수 (device-web과 동일한 로직)
  const handleMobileLogout = () => {
    console.log("[handleMobileLogout] 모바일 로그아웃 처리 시작");

    // 🎯 bridgeLogout 함수 사용 (androidInterface.logout() 직접 호출)
    bridgeLogout();
  };

  const onMemberOut = async () => {
    let res = await withdrawMembership();
    if (isEmbed()) {
      // 앱 일경우
      if (res) {
        sendToAndroid("go-to-page", "login");
        bridgeLogout();
      }
    } else {
      // 웹 일경우
      logout();
      navigate("/");
    }
  };

  /* for mobile ================================================================================= */
  useEffect(() => {
    if (!isAuthenticated) return setData(undefined);

    refreshUser()
      .then((res: any) => {
        const profile = res?.user_profile;
        const membership = res?.membership;
        const project = res?.project;
        const delivery = res?.delivery;
        const progress = res?.progress;

        if (profile) {
          const data = {
            ...user,
            ...profile,
            ...(membership ? { membership: membership } : {}),
            ...(project ? { project: project } : {}),
            ...(delivery ? { delivery: delivery } : {}),
            ...(progress ? { progress: progress } : {}),
          };

          serUserInfo(data);
        }
        setData(res);
      })
      .catch((error) => {
        console.error("사용자 정보 새로고침 실패:", error);
        setData(undefined);
        serUserInfo({});
      });
  }, [isAuthenticated]);

  useEffect(() => {
    let id = searchParams.get(`id`);
    if (data) {
      setTimeout(() => {
        if (id) {
          const el = document.getElementById(id);
          if (el) {
            el.scrollIntoView({ behavior: "smooth" });
          }
        }
      }, 500);
    }
    console.log(id, "/[ids123]");
  }, [data]);

  console.log(data);
  console.log(searchParams);
  console.log(userInfo);
  // console.log(loaction?.hash);

  if (!isAuthenticated) {
    return (
      <>
        <div className={`content_wrap mypage`}>
          <div className={`section_wrap`}>
            <div className={`sec`}>로그인 해주세요.</div>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        {/* 앱 전용 버튼 */}
        {isEmbed() && (
          <div className={`mobile_app_header`}>
            <button
              onClick={() => sendToAndroid("go-to-page", "")}
              className={`btn btn_back`}
            ></button>
            <p className={`mobile_app_header_text`}>내 정보</p>
          </div>
        )}
        <div className={`content_wrap mypage`}>
          {!isEmbed() && <Banner userInfo={userInfo} />}
          <div className={`section_wrap`}>
            {/** ==============================================================**/}
            {/** ==============================내정보===========================**/}
            {/** ==============================================================**/}
            <UserInfo
              actType={actType}
              userInfo={userInfo}
              onSubmit={(res: any) => {
                setActType(res?.actType);
                serUserInfo((prev: any) => ({ ...prev, ...res })); // 상태 업데이트
              }}
            />
            {/** ==============================================================**/}
            {/** ========================이용중인 상품===========================**/}
            {/** ==============================================================**/}
            <OrderInfo navigate={navigate} userInfo={userInfo} />
            {/** ==============================================================**/}
            {/** ======================내가 선물한 쿠폰===========================**/}
            {/** ==============================================================**/}
            <Coupon userInfo={userInfo} />
            <div className={`sec btn_group flex justify-center`}>
              <button className={`btn`} onClick={() => setMembershipOut(true)}>
                회원 탈퇴
              </button>
              <button
                className={`btn`}
                onClick={() => {
                  if (isEmbed()) {
                    setLogOutgPopup(true);
                  } else {
                    logout();
                    navigate("/");
                  }
                }}
              >
                로그아웃
              </button>
            </div>
          </div>
        </div>
        {membershipOut && (
          <YesNoPopup
            description="탈퇴하시겠어요? 구매한 상품, 인터뷰 내역, 생성된 책이 모두 삭제되며, 복구할 수 없습니다."
            confirmText="탈퇴"
            cancelText="회원 유지"
            notifyNative={isEmbed()}
            onCancel={() => {
              setMembershipOut(false);
            }}
            onExit={onMemberOut}
          />
        )}
        {logOutgPopup && (
          <YesNoPopup
            description="로그아웃 하시겠어요?"
            confirmText="로그아웃"
            cancelText="취소"
            notifyNative={isEmbed()} // 🎯 모바일 환경에서 네이티브 통신 활성화
            onCancel={() => {
              setLogOutgPopup(false);
            }}
            onExit={() => {
              // 🎯 로그아웃 처리 시작
              console.log("🔐 로그아웃 처리 시작");

              // 🎯 isEmbed() 분기로 웹/모바일 처리 구분
              if (isEmbed()) {
                // 🎯 모바일 환경: handleMobileLogout 함수 사용
                console.log("📱 모바일 환경 로그아웃 처리 시작");
                handleMobileLogout();
              }
            }}
          />
        )}
      </>
    );
  }
};

export default MyPage;
